<template>
<svg :width="width" :height="height" viewBox="0 0 194 194" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_141_172976)">
<rect width="194" height="194" fill="transparent"/>
<g filter="url(#filter0_d_141_172976)">
<rect x="-68" y="165.91" width="311" height="32" transform="rotate(-45 -68 165.91)" fill="#464646"/>
</g>
<g filter="url(#filter1_d_141_172976)">
<rect x="24" y="21" width="72" height="72" rx="36" fill="white"/>
<rect x="28.75" y="25.75" width="62.5" height="62.5" rx="31.25" fill="white"/>
<rect x="28.75" y="25.75" width="62.5" height="62.5" rx="31.25" stroke="#515A63" stroke-width="1.5"/>
<path d="M74.0001 72.4022L70.5 78.7019C70.5 78.7019 65.187 71.6882 60 64.0657C61.288 62.1758 62.576 60.2439 63.766 58.375L63.815 58.403C66.608 62.4698 69.975 67.1525 74.0001 72.4022Z" fill="#35383B"/>
<path d="M54.4562 43.5489C55.6882 45.7467 57.5012 48.7986 60.0002 52.6624C58.8872 54.3913 57.6272 56.2835 56.2202 58.339C52.9932 53.2923 50.4452 48.7006 50.2002 46.4957C50.2002 46.4957 50.9002 40.896 52.3002 39.4961C52.3002 39.4961 52.9512 40.882 54.4562 43.5489Z" fill="#35383B"/>
<path d="M65.5441 43.5489C67.0491 40.882 67.7001 39.4961 67.7001 39.4961C69.1001 40.896 69.8001 46.4957 69.8001 46.4957C69.5551 48.7006 66.9931 53.3063 63.7661 58.367C62.5761 60.2359 61.2881 62.1678 60.0001 64.0577C54.813 71.6733 49.5 78.6939 49.5 78.6939L46 72.3942C50.046 67.1235 53.427 62.4198 56.22 58.339C57.627 56.2858 58.887 54.3936 60.0001 52.6624C62.4991 48.7986 64.3051 45.7397 65.5441 43.5489Z" fill="#52575C"/>
<path d="M67.7008 39.5007C67.7008 39.5007 67.0498 40.8867 65.5448 43.5535C65.2998 42.9795 64.1378 40.9007 60.0008 40.9007C55.8638 40.9007 54.7018 42.9795 54.4568 43.5535C52.9518 40.8867 52.3008 39.5007 52.3008 39.5007C53.1304 38.2124 54.27 37.1528 55.6153 36.419C56.9605 35.6853 58.4684 35.3008 60.0008 35.3008C61.5332 35.3008 63.0411 35.6853 64.3864 36.419C65.7316 37.1528 66.8713 38.2124 67.7008 39.5007Z" fill="#222426"/>
</g>
</g>
<defs>
<filter id="filter0_d_141_172976" x="-78" y="-62" width="262.538" height="262.539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.207843 0 0 0 0 0.290196 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_141_172976"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_141_172976" result="shape"/>
</filter>
<filter id="filter1_d_141_172976" x="14" y="13" width="92" height="92" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.207843 0 0 0 0 0.290196 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_141_172976"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_141_172976" result="shape"/>
</filter>
<clipPath id="clip0_141_172976">
<rect width="194" height="194" fill="white"/>
</clipPath>
</defs>
</svg>
</template>
<script>  
export default {
  name: 'RibbonBand',
  props: {
    width: {
      type: String,
      default: '214px',
    },
    height: {
      type: String,
      default: '214px',
    },
  },
}
</script>